<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="center_text mb-21 certificate">
            <p>이전 예약 내역</p>
            <p>
              <b>{{userName}}</b>님
            </p>
          </div>
          <div class="title_wrap reCare center pb-15">
            <span class="warn">예약을 진행할 진료과와 원장님을 선택해주세요.</span>
          </div>
        </div>
        <div class="card_wrap">
          <div
            class="card_list selectList"
            @click="selectedItem(i)"
            v-for="(reservationInfo, i) in checkDataSet"
            :key="i"
          >
            <div class="cl_title whiteHover">
              <h2>{{reservationInfo.doctorName}}</h2>
              <div class="cl_btn">
                <button type="button" class="redHover">선택</button>
              </div>
            </div>
            <div class="cl_content black">
              <div class="content_item">
                <div class="ci_title">
                  <label>수술명</label>
                </div>
                <div class="ci_content">
                  <p
                    v-if="(reservationInfo.surgeryReason !==  '')"
                    class="reason"
                  >{{(reservationInfo.surgeryReason) | getContent()}}</p>
                  <p v-else>{{reservationInfo.surgeryReason}}</p>
                  <p
                    v-if="(reservationInfo.checkupReason !==  '')"
                    class="reason"
                  >{{(reservationInfo.checkupReason) | getContent()}}</p>
                  <p v-else>{{reservationInfo.checkupReason}}</p>
                </div>
              </div>
              <div class="content_item">
                <div class="ci_title">
                  <label>내원일</label>
                </div>
                <div class="ci_content">
                  <p>{{reservationInfo.reservationDate | moment('YYYY.MM.DD')}} {{reservationInfo.reservationDate | moment('LT')}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          <div class="label_box_wrap">-->
        <!--            <div class="label_box" @click="selectedItem(i)" v-for="(reservationInfo, i) in checkDataSet" :key="i">-->
        <!--              <div class="lb_item pointer">-->
        <!--              <p>진료과: {{reservationInfo.doctorName}}-->
        <!--                <b v-if="(reservationInfo.surgeryReason !==  '')" class="reason">{{(reservationInfo.surgeryReason) | getContent()}}</b>-->
        <!--                <b v-else>{{reservationInfo.surgeryReason}}</b>-->
        <!--                <b v-if="(reservationInfo.checkupReason !==  '')" class="reason">{{(reservationInfo.checkupReason) | getContent()}}</b>-->
        <!--                <b v-else>{{reservationInfo.checkupReason}}</b>-->
        <!--                </p>-->
        <!--                <p>내원일: {{reservationInfo.reservationDate | formatTimeList}}</p>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <div class="description reCare">
          <div class="imgWrap">
            <img src="@/assets/images/caution.svg" />
          </div>
          <p>음성치료가 필요한 환자는 전화연결을 통해</p>
          <p>예약하시기 바랍니다.</p>
          <p>모바일 앱으로 예약 시 경우에 따라 내원 당일</p>
          <p>음성치료가 어려울 수 있습니다.</p>
        </div>
        <div class="title_wrap reCare center">
          <span class="warn" v-if="trueData && isHistory">위와 동일한 내용으로 예약을 진행하시겠습니까?</span>
          <span class="warn" v-if="trueData && isFuture">선택한 예약내역을 조회/변경하시겠습니까?</span>
        </div>
        <!--          <div class="searchListWrap modalPage">-->
        <!--            <div class="reservationAgo">-->
        <!--              <div class="headerImgWrap">-->
        <!--                <img src="@/assets/images/join_1.svg" />-->
        <!--              </div>-->
        <!--              <div class="header">-->
        <!--                <h5>[이전 예약 내역]</h5>-->
        <!--                <p><b class="name">{{userName}}</b>님</p>-->
        <!--              </div>-->

        <!--              <div class="reservationItemWrap">-->
        <!--                <div class="item" @click="selectedItem(i)" v-for="(reservationInfo, i) in checkDataSet" :key="i">-->
        <!--                  <p>내원사유: <b class="doctor">{{reservationInfo.doctorName}}</b></p>-->
        <!--                  <p v-if="(reservationInfo.surgeryReason !==  '')"><b class="reason">{{(reservationInfo.surgeryReason) | getContent()}}</b> </p>-->
        <!--                  <p v-else><b class="reason">{{reservationInfo.surgeryReason}}</b> </p>-->
        <!--                  <p v-if="(reservationInfo.checkupReason !==  '')"><b class="reason">{{(reservationInfo.checkupReason) | getContent()}}</b></p>-->
        <!--                  <p v-else><b class="reason">{{reservationInfo.checkupReason}}</b></p>-->
        <!--                  <p>내원일: <b class="date">{{reservationInfo.reservationDate | formatTimeList}}</b></p>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--              <div class="buttonCluster" v-if="isHistory">-->
        <!--                <button type="button" class="cancel" @click="newReservation()">다른 이유로 내원</button>-->
        <!--                <button type="button" class="confirm" @click="settingDate()">네</button>-->
        <!--              </div>-->
        <!--              <div class="buttonCluster" v-if="isFuture">-->
        <!--                <button type="button" class="cancel" @click="newReservation()">다른 이유로 내원</button>-->
        <!--                <button type="button" @click="updateDate()">예약조회/변경</button>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          <div class="bottomTextWrap">-->
        <!--            <div class="imgWrap">-->
        <!--              <img src="@/assets/images/caution.svg">-->
        <!--            </div>-->
        <!--            <p>음성치료가 필요한 환자는 전화연결을 통해 예약하시기 바랍니다. 모바일 앱으로 예약 시 경우에 따라 내원 당일 음성치료가 어려울 수 있습니다.</p>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div class="btnWrap half visible" v-if="isHistory">
        <button type="button" class="callTerms cancel" @click="newReservation()">다른 이유로 내원</button>
        <button type="submit" class="callTerms" @click="dateCheck()">예약하기</button>
      </div>
      <div class="btnWrap half visible" v-if="isFuture">
        <button type="button" class="callTerms cancel" @click="newReservation()">다른 이유로 내원</button>
        <button type="submit" class="callTerms" @click="dateCheck()">예약조회/변경</button>
      </div>
    </div>
    <add-popup v-if="checkPopup" :popupSet="popupSet" @causeAction="dateCheck()" />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { getCookie } from '../../../utils/cookieNew'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        prevLink: '/reservation/selectDisease',
        closeType: 'close',
        currentURL: '/reservation/reCare'
      },
      transDate: {
        headerName: '이전 예약 내역',
        prevUrl: '/'
      },
      selectedOrder: '',
      userName: '',
      dataFlag: null,
      doctorCode: '',
      doctorName: '',
      doctorPhotourl: '',
      bookingCode: '',
      today: '',
      currentYear: '',
      currentMonth: '',
      currentDay: '',
      currentDaysSet: [],
      currentDayLast: '',
      lastDayment: '',
      dateStart: '',
      dateEnd: '',
      IsWhole: '',
      isHistory: '',
      popupHistory: [],
      isFuture: '',
      reservationDate: '',
      trueData: false,
      firstDataSet: false,
      checkDataSet: {},
      IsSurgeryReason: '',
      setCount: false
    }
  },
  computed: {
    ...mapGetters(['GET_RESERVATION_CHECK', 'getVisitList']),
    ...mapState(['checkPopup'])
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.getDefaultDate()
    this.resvPrepare()
  },
  filters: {
    formatTimeList: function (value) {
      value = value.toString()
      const date = value.substr(0, 10)
      const time = value.substr(11, 14)
      const target = date + '\n' + time
      return target
    },
    getContent (value) {
      if (value !== null) {
        console.log('정보있나요?', value.content)
        return value.content
      }
    }
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_RESERVATION_SEARCH',
      'SET_RESV_CODE',
      'SET_VISIT_LIST'
    ]),
    ...mapActions(['CHECK_RESERVATION']),
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    async resvPrepare () {
      try {
        await this.CHECK_RESERVATION().then(() => {
          this.fetchDataReCare()
        })
      } catch (error) {
        console.log('error :', error);
        console.log('재예약 여부 조회 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    dateCheck () {
      if (this.isHistory) {
        this.settingDate()
      }
      if (this.isFuture) {
        this.updateDate()
      }
    },
    newReservation () {
      this.SET_RESV_CODE(this.selectedOrder)
      this.$router.push('/reservation/selectDisease')
    },
    settingDate () {
      if (this.trueData) {
        const bookingDataSet = {
          bookingCode: this.bookingCode,
          year: this.currentYear,
          month: this.currentMonth,
          day: this.currentDay,
          doctorCode: this.doctorCode,
          doctorName: this.doctorName,
          doctorPhotoUrl: this.doctorPhotoUrl
        }
        console.log('bo', bookingDataSet)
        this.SET_POPUP(true)
        this.popupSet.count = 'double'
        this.popupSet.content =
          '<p>위와 동일한 내용으로 </p><p>예약을 진행하시겠습니까?</p>'
        this.popupSet.confirmBtnText = '확인'
        this.popupSet.cancelBtnText = '취소'
        this.popupSet.nextLink = '/reservation/rebooking'
        this.$store.commit('SET_REBOOKINGSET', bookingDataSet)
      } else {
        this.SET_POPUP(true)
        this.popupSet.content = '예약내역을 선택해주세요.'
      }
    },
    tranferTime: function (value) {
      value = value.toString()
      const date = value.substr(0, 10)
      return date
    },
    updateDate () {
      const dateSet = this.reservationDate
      const getYear = dateSet.substr(0, 4)
      const getMonth = dateSet.substr(5, 2)
      console.log('year', getYear)
      console.log('month', getMonth)
      const lastDate = new Date(Number(getYear), Number(getMonth), 0).getDate()
      console.log('마지막날은', lastDate)
      const gte = getYear + '-' + getMonth + '-' + '01'
      const lte = getYear + '-' + getMonth + '-' + lastDate

      if (this.trueData) {
        const dateList = []
        dateList.push(gte)
        dateList.push(lte)
        dateList.push(false)
        this.SET_POPUP(true)
        this.popupSet.count = 'double'
        this.popupSet.content =
          '<p>선택한 예약내역을 </p> <p>조회/변경하시겠습니까?</p>'
        this.popupSet.confirmBtnText = '확인'
        this.popupSet.cancelBtnText = '취소'
        this.popupSet.nextLink = '/reservation/reservationConfirm'
        this.$store.commit('SET_RESERVATION_SEARCH', dateList)
      } else {
        this.SET_POPUP(true)
        this.popupSet.content = '변경할 예약내역을 선택해주세요.'
      }
    },
    getUserName () {
      const userName = getCookie('userName')
      this.userName = userName
    },
    // 재진정보를 불러옴
    fetchDataReCare () {
      const checkDataSetMoto = []
      checkDataSetMoto.push(this.GET_RESERVATION_CHECK[0])
      if (this.GET_RESERVATION_CHECK[0].flag === 'history') {
        this.isHistory = true
      }
      if (this.GET_RESERVATION_CHECK[0].flag === 'future') {
        this.isFuture = true
      }
      this.checkDataSet = checkDataSetMoto
      this.getUserName()
      /*   console.log('몇개있나 계산할 수 있어?', this.GET_RESERVATION_CHECK.length)
      const doctorName = this.GET_RESERVATION_CHECK.doctorName
      if (this.GET_RESERVATION_CHECK.surgeryReason !== '') {
        const surgeryReason = this.GET_RESERVATION_CHECK[0].surgeryReason
        this.checkDataSet.surgeryReason = surgeryReason
        this.IsSurgeryReason = true
      }
      if (this.GET_RESERVATION_CHECK.checkupReason !== '') {
        const checkupReason = this.GET_RESERVATION_CHECK[0].checkupReason
        this.checkDataSet.checkupReason = checkupReason
        this.IsSurgeryReason = false
      }
      const job = this.GET_RESERVATION_CHECK.job
      this.checkDataSet.doctorName = doctorName
      this.checkDataSet.job = job
      //  const reservationDate = this.GET_RESERVATION_CHECK.reservationDate
    //  this.checkDataSet.reservationDate = reservationDate */
    },
    selectedItem (order) {
      this.selectedOrder = order
      const findItem = document.querySelector('.card_wrap').childNodes[order]
      const repeat = document.querySelector('.card_wrap').childNodes.length

      for (let i = 0; i < repeat; i++) {
        console.log('루프돔')
        document
          .querySelector('.card_wrap')
          .childNodes[i].classList.remove('selected')
      }
      if (this.dataflag === order) {
        this.dataflag = null
        this.trueData = false
      } else {
        this.trueData = true
        this.dataflag = order
        this.bookingCode = this.checkDataSet[order].bookingCode
        this.doctorCode = this.checkDataSet[order].doctorCode
        this.doctorName = this.checkDataSet[order].doctorName
        this.doctorPhotoUrl = this.checkDataSet[order].doctorPhotoUrl
        this.reservationDate = this.tranferTime(
          this.checkDataSet[order].reservationDate
        )
        findItem.classList.add('selected')
      }
    },
    getPopUp () {
      this.popupSet.longHeight = true
      this.popupSet.specialPick = true
      this.popupSet.modalImg = 'caution.svg'
      this.popupSet.cancelBtnText = '뒤로가기'
      this.popupSet.confirmBtnText = '계속진행하기'
      this.SET_POPUP(true)
    },
    // 오늘과 마지막일짜를 구하는 함수
    getDefaultDate () {
      const existDate = []
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const dateMutated = new Date(year, month, 0)
      console.log('datedMutated', dateMutated)
      const lastDay = dateMutated.getDate()
      let monthValue
      let dayValue
      let transDate
      let today
      if (String(month).length < 2) {
        monthValue = '-0' + String(month)
      } else {
        monthValue = '-' + String(month)
      }
      if (String(day).length < 2) {
        dayValue = '-0' + String(day)
      } else {
        dayValue = '-' + String(day)
      }
      console.log('재료', String(year) + String(monthValue) + String(dayValue))
      const material = String(year) + monthValue + '-'
      const material2 = String(year) + monthValue + '-0'
      const repeatLength = day
      for (let i = 1; i < repeatLength + 1; i++) {
        if (i < 10) {
          transDate = material2 + i
        } else {
          transDate = material + i
        }
        existDate.push(transDate)
      }
      if (String(day).length < 2) {
        today = String(material2 + day)
      } else {
        today = String(material + day)
      }
      const lastDayment = String(material + lastDay)
      this.currentYear = year
      this.currentMonth = month
      this.currentDay = day
      this.today = today
      this.currentDaysSet = existDate
      this.currentDayLast = lastDay
      this.lastDayment = lastDayment
    }
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    this.setCount = false
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  }
}
</script>

<style lang="scss" scoped>
</style>
